import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import About from '../views/About.vue';
import Root from '../views/Root.vue';
import SearchResults from '../views/SearchResults.vue';
import SearchHeader from '../views/SearchHeader.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import CookiePolicy from '../views/CookiePolicy.vue';
import { Constants } from '../constants';
import { Routes } from './routes';
import HomePage from '../views/HomePage.vue';
import Support from "../views/Support.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    children: [
      {
        children: [
          {
            path: '',
            component: HomePage,
            name: Routes.Home,
          },
          {
            path: 'search',
            name: Routes.Search,
            component: SearchResults,
          },
        ],
        path: '',
        component: SearchHeader,
      },
      {
        path: 'about',
        name: Routes.About,
        component: About,
      },
      {
        path: 'privacy',
        name: Routes.PrivacyPolicy,
        component: PrivacyPolicy,
      },
      {
        path: 'cookies',
        name: Routes.CookiePolicy,
        component: CookiePolicy,
      },
      {
        path: 'support',
        name: Routes.Support,
        component: Support
      }
    ],
    path: '/',
    component: Root,
  },
  {
    path: '*',
    name: 'catchAll',
    redirect: {
      name: Routes.Home,
    },
  },
];

const router = new VueRouter({
  base: Constants.PublicPath,
  routes,
  mode: 'history',
});

export default router;
